export default __webpack_public_path__ + "static/media/ShiftAssetIcon.45c82a32.svg";